module.exports = __webpack_public_path__ + "static/media/consultancy.5872af8b.png";